<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card title="Image Yükle">
          <pre-loading v-if="uploading" />
          <template v-else>
            <!-- Eğer logo mevcutsa resmi görüntülemek için b-img kullanıyoruz -->
            <b-img
              v-if="itemData.image"
              :src="baseURL + '/media/services/' + itemData.image"
              alt="Görsel"
              fluid
              class="mb-3"
            />
            <b-button
              v-if="itemData.image"
              variant="outline-danger"
              size="sm"
              pill
              class="btn-icon mt-1"
              @click="removeImage(itemData)"
            >
              <FeatherIcon icon="TrashIcon" />
            </b-button>
            <b-form-file
              id="image-file"
              v-model="image"
              class="mt-1"
              placeholder="Bir dosya seçin veya buraya bırakın..."
              drop-placeholder="Dosyayı buraya bırakın..."
              browse-text="Dosya Seçin"
            />
            <div class="mt-1">
              <b-button
                variant="primary"
                :disabled="!image"
                @click="uploadFile"
              >
                <FeatherIcon icon="UploadIcon" />
                Görsel Yükle
              </b-button>
            </div>
          </template>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BButton, BCard, BCol, BRow, BFormFile, BImg,
} from 'bootstrap-vue'
import PreLoading from '@/layouts/components/common/PreLoading.vue'

export default {
  name: 'ImageUploadCard',
  components: {
    BRow,
    BCol,
    BButton,
    BCard,
    BFormFile,
    BImg,
    PreLoading,
  },
  data() {
    return {
      baseURL: this.$store.state.app.baseURL,
      image: null,
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['services/dataItem']
    },
    uploading() {
      return this.$store.getters['fileUpload/uploading']
    },
  },
  methods: {
    uploadFile() {
      const formData = new FormData()
      formData.append('file', this.image)

      this.$store.dispatch('fileUpload/uploadFile', {
        upload_file: this.image,
        folder: 'services',
      })
        .then(response => {
          this.itemData.image = response.filename
        })
        .catch(error => {
          console.error('Dosya yükleme hatası:', error)
        })
    },
    removeImage(data) {
      // console.log(fieldImage, fieldThumb)
      const params = {
        id: data.id,
        image: data.image,
        thumb: data.thumb,
        folder: 'services',
      }
      if (data.id) {
        this.$store.dispatch('services/removeServiceImageData', params)
          .then(response => {
            if (response) {
              console.log(response)
            }
          })
      } else {
        console.log(data.id)
      }
    },
  },
}
</script>
